import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useTheme } from '../ThemeContext';

const ToggleButton = styled(motion.button)`
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 1000;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${props => props.theme.colors.surfaceCard};
  backdrop-filter: blur(20px);
  border: 1px solid ${props => props.theme.colors.borderSubtle};
  box-shadow: ${props => props.theme.shadows.card};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: ${props => props.theme.shadows.glow};
    border-color: ${props => props.theme.colors.accentPurple};
  }

  @media (max-width: 768px) {
    top: 16px;
    right: 16px;
    width: 40px;
    height: 40px;
  }
`;

const IconWrapper = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SunIcon = ({ color }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="4" stroke={color} strokeWidth="2" />
        <path d="M12 2V4M12 20V22M2 12H4M20 12H22" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path d="M4.93 4.93L6.34 6.34M17.66 17.66L19.07 19.07M4.93 19.07L6.34 17.66M17.66 6.34L19.07 4.93" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const MoonIcon = ({ color }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ThemeToggle = () => {
    const { mode, toggleTheme, theme } = useTheme();
    const isDark = mode === 'dark';

    return (
        <ToggleButton
            theme={theme}
            onClick={toggleTheme}
            whileTap={{ scale: 0.9 }}
            title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
            aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
            <IconWrapper
                key={mode}
                initial={{ rotate: -90, opacity: 0 }}
                animate={{ rotate: 0, opacity: 1 }}
                exit={{ rotate: 90, opacity: 0 }}
                transition={{ duration: 0.3 }}
            >
                {isDark ? (
                    <SunIcon color={theme.colors.accentPurple} />
                ) : (
                    <MoonIcon color={theme.colors.accentPurple} />
                )}
            </IconWrapper>
        </ToggleButton>
    );
};

export default ThemeToggle;
